export enum ESidebarItemHeadingType {
  EndUserHeading = 'end-user-heading',
  Heading = 'heading',
  Title = 'title'
}
